import fs from 'node:fs'
import path from 'node:path'
import { snapshotTargetPath } from '@core-engine/snapshots/store/snapshot-target-path.js'

export function writeBackupFile(
  cwd: string,
  filePath: string,
  content: string,
  suffix = '.bak'
): void {
  const backupPath = `${snapshotTargetPath(cwd, filePath)}${suffix}`
  fs.mkdirSync(path.dirname(backupPath), { recursive: true })
  fs.writeFileSync(backupPath, content, 'utf-8')
}
